import styles from "./loader.module.css";
import React, {
  useEffect,
  useRef,
  forwardRef,
  useImperativeHandle,
} from "react";
import lottie from "lottie-web";
import animationData from "./loader-img/loader.json"; // Шлях до вашого JSON файлу

const Loader = (props, ref) => {
  const refLoader = useRef(null);
  const containerRef = useRef(null);


  useEffect(() => {
    const animation = lottie.loadAnimation({
      container: containerRef.current, // елемент для анімації
      renderer: "svg", // тип рендерера
      loop: true, // безкінечний цикл
      autoplay: true, // автоматичний старт
      animationData: animationData, // самі дані анімації
    });

    // Прибирання анімації при розмонтуванні компонента
    return () => {
      animation.destroy();
    };
  }, []);

  return (
    <>
      <div ref={refLoader} className={`${styles.loaderWrapper} ${styles.hidden}`}>
        <div className={styles.loader}>
          <div
            className={styles.loaderAnimation}
            ref={containerRef}
          />
        </div>
      </div>
    </>
  );
};

export default Loader;
